import * as React from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/reduxDispatch";
import { apiCreateChatBot } from "../../../../services/apiCalls/user/chatbot";
import { useNavigate } from "react-router";
import { apiErrorMessage } from "../../../../utils/apiErrorCall";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Button from "../../../../components/Button";
import colors from "../../../../theme/color";
import Modal from "../../../../components/modal";

export default function ChatBotName({ open, setOpen }) {
  //   const [open, setOpen] = React.useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { userProfile } = useAppSelector((s) => s.userProfile);

  // "loading" | "success" | "error" | "idle"
  const [status, setStatus] = React.useState("idle");
  const [botName, setBotName] = React.useState("");
  const [description, setDescription] = React.useState("");

  //   const handleClickOpen = () => {
  //     setOpen(true);
  //   };

  const handleClose = () => {
    setOpen(false);
  };

  const processCreateChatBot = (e) => {
    e.preventDefault();
    if (botName) {
      setStatus("loading");
      dispatch(
        apiCreateChatBot(
          {
            userId: userProfile._id,
            botName,
          },
          setStatus
        )
      );
    } else {
      setStatus("idle");
      apiErrorMessage({ message: "Please name your bot" });
    }
  };

  React.useEffect(() => {
    // console.log(open, "open");
    if (status === "success") {
      navigate("/user/dashboard/bot/editBot");
      setStatus("idle");
      setBotName("");
      setDescription("");
    }
  }, [status]);

  return (
    <>
      <ToastContainer />
      <Modal>
        <form
          // onSubmit={processCreateChatBot}
          className="space-y-6 w-64 sm: 80 md:w-96"
        >
          <div>
            <label htmlFor="name" className="text-lg text-gray-600 block">
              Name
            </label>
            <input
              type="text"
              id="text"
              placeholder="My first bot"
              value={botName}
              onChange={(e) => setBotName(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg mt-1"
            />
          </div>

          <div className="">
            <label htmlFor="email" className="text-lg text-gray-600 block">
              Description
            </label>
            <textarea
              id="textArea"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className=" block w-full p-2.5 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
              placeholder="Chat bot description"
            />
          </div>
          <div className="flex justify-between">
            <Button disabled={status === "loading"} onClick={handleClose}>
              Cancel
            </Button>
            {status === "loading" && <div className="loader"></div>}
            <Button
              disabled={status === "loading"}
              onClick={(e) => processCreateChatBot(e)}
            >
              Confrim
            </Button>
          </div>
        </form>
      </Modal>

      {/* </div> */}
    </>
  );
}
